import { Link } from 'react-router';
import errorImg from './500.svg';
import { Button } from '@agently/ui';

export const Error500 = () => {
  return (
    <div className="grid place-content-center h-full py-24 px-4 text-center gap-3">
      <img src={errorImg} alt="error" className="w-1/2 mx-auto" />
      <div className="text-2xl font-bold">Opps! Something Went Wrong</div>
      <div className="text-sm text-gray-500">
        You didn’t break the internet, but we can’t find what are you looking
        for.
      </div>
      <div>
        <Link to="/">
          <Button>Go to Home</Button>
        </Link>
      </div>
    </div>
  );
};
